import { z } from 'zod';
import { paginatedSchema, paginationQuerySchema } from '../common/pagination.schema.js';
import { userDtoSchema, userRoleSchema } from './user.schemas.js';

export const adminUserListQuerySchema = paginationQuerySchema.extend({
  role: userRoleSchema.optional(),
  search: z.string().min(1).max(255).optional(),
});

export const adminUserListSchema = paginatedSchema(userDtoSchema);

export const updateUserRoleSchema = z.object({
  role: userRoleSchema,
});

export type AdminUserListQuery = z.infer<typeof adminUserListQuerySchema>;
export type UpdateUserRoleInput = z.infer<typeof updateUserRoleSchema>;
